import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPanelPath_actionType } from "../../../../redux/constants";
import { EMBED_VARIANTS } from "../../../../utils/helper";
import { Button, Tooltip } from "../../../UI";
import {
  getModulesWithReports,
  getOperationsWithReports,
  getReports,
  replaceURLParams,
} from "../helpers";
import { StyledReportButton } from "./ReportButton-styled";

export const ReportButton = ({ config, t, isOnMap }) => {
  const dispatch = useDispatch();
  const { activeModule, mobileReducer } = useSelector((store) => store);

  useEffect(() => {
    if (config.embed === EMBED_VARIANTS.APP) {
      return;
    }

    if (config.datacollection === "open") {
      let reports = [];
      const urlParams = new URLSearchParams(window.location.search);
      const urlModule = urlParams.get("module");
      const urlDataCollection = urlParams.get("datacollection");
      const urlOp = urlParams.get("op");

      if (urlDataCollection) {
        if (urlModule) {
          reports = getReports(config, activeModule);
        } else if (urlOp) {
          reports = getModulesWithReports(config);
        } else {
          reports = getOperationsWithReports(config);
        }
      } else if (urlOp) {
        reports = getReports(config, activeModule);
      }

      if (reports.length > 0) {
        if (mobileReducer.isMobileApp) {
          setTimeout(() => {
            setPanelPath("reportAll");
          }, 1500);
        } else {
          setPanelPath("reportAll");
        }
      }
    } else {
      setPanelPath("");
    }
  }, []);

  const setPanelPath = (newPath) => {
    dispatch({ type: setPanelPath_actionType, payload: newPath });
  };

  const reportType = useMemo(() => {
    const reports =
      config.modules[activeModule]?.reports ??
      config.opDefaults.modules[activeModule]?.reports ??
      [];
    const urlParams = new URLSearchParams(window.location.search);

    if (!urlParams.has("op") || reports.length > 0) {
      return "reportAll";
    }
  }, [config, activeModule]);

  const openReports = () => {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has("op")) {
      replaceURLParams([{ key: "datacollection", value: "open" }]);
    } else {
      const op = urlParams.get("op");
      const params = [
        {
          key: "op",
          value: op,
        },
        {
          key: "module",
          value: activeModule.toLowerCase(),
        },
        {
          key: "datacollection",
          value: "open",
        },
      ];
      replaceURLParams(params);
    }

    setPanelPath(reportType);
  };

  if (!reportType || config.embed === EMBED_VARIANTS.APP) return <></>;

  return (
    <>
      {!isOnMap && (
        <div
          style={{
            margin: "0px 4px",
            width: "1px",
            height: "calc(100% - 18px)",
            background: "#e4e4e4",
          }}
        />
      )}
      <Tooltip
        content={t("screen.popup.actions.report")}
        placement="bottom"
        showOnHover
        blurred
      >
        <Button
          id="report-widget--open"
          className="onboarding-report gtag text-elipsis"
          data-tag-name="Report-Start"
          onClick={openReports}
          bg="var(--opsColor)"
          style={{ borderRadius: 100, minWidth: 40, height: 40 }}
          isNew
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <svg
              stroke="currentColor"
              fill="#fff"
              strokeWidth="0"
              viewBox="0 0 448 512"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
            </svg>
          </div>
        </Button>
      </Tooltip>
    </>
  );

  return (
    <StyledReportButton
      id="report-widget--open"
      className="onboarding-report gtag"
      data-tag-name="Report-Start"
      onClick={openReports}
    >
      <span>{t("screen.popup.actions.report")}</span>
      {/* <svg
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
        viewBox="0 0 24 24"
        strokeLinecap="round"
        strokeLinejoin="round"
        height="18"
        width="18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
        <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z"></path>
      </svg> */}
      <svg
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
        viewBox="0 0 24 24"
        strokeLinecap="round"
        strokeLinejoin="round"
        height="22"
        width="22"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="16"></line>
        <line x1="8" y1="12" x2="16" y2="12"></line>
      </svg>
    </StyledReportButton>
  );
};

export default ReportButton;
